import { SQLService } from '../services/sql.service';
import { Component, OnInit } from '@angular/core';
import { Router,NavigationEnd } from '@angular/router';
import { PopoverController} from '@ionic/angular';
import { VacationsMenuComponent } from './vacations-menu/vacations-menu.component';
@Component({
  selector: 'ng-cheques-vacations',
  templateUrl: './vacations.component.html',
  styleUrls: ['./vacations.component.styl']
})
export class VacationsComponent implements OnInit {
  constructor(
    private router: Router,
    public popoverController: PopoverController,
    public sql: SQLService
  ) {
    this.router.events.subscribe((eve) => {
      if(eve instanceof NavigationEnd) this.get_vacations();
    });
  }
  vacations = [];
  count = -1;
  search: string;
  filter(e) { this.search=e.target.value; }
  add() { this.router.navigate(['folder','Vacation','New']); }
  end() {this.router.navigate(['folder','Dashboard']);}
  showing_popover:boolean;lpevent:any;
  _md(e){this.lpevent=e;}
  async popover(item?) {
    if(this.showing_popover)return;
    this.showing_popover=true;
    this.sql.hapticsImpactMedium();
    var popover = await this.popoverController.create({
      component:VacationsMenuComponent,
      cssClass: 'popover_container',
      translucent: true,
      componentProps: {enabled: item.enabled},
      event: this.lpevent?this.lpevent:false
    });
    popover.present();
    var { data } = await popover.onWillDismiss();
    if (data && item) {
      this.sql.hapticsImpactLight();
      if(data=='enable')this.enable(item);
      if(data=='disable')this.disable(item);
      if(data=='delete')this.delete(item, false);
    }
    this.showing_popover=false;
    this.lpevent=null;
  }
  get_vacations(event?) {
    this.sql.fetch('Vacations',(e)=>{
      if(e)this.vacations=e;
      this.count=e.length;
      setTimeout(()=>{
        if (event) event.target.complete();
      },1234);
    });
  }
  edit(vacation, item?) {
    this.router.navigate(['folder','Vacation',vacation.vacation_id]);
    if(item)item.closeSlidingItems(); 
  }
  enable_disable(vacation,i?) {
    if(vacation.enabled) {
      this.disable(vacation)
    } else {
      this.enable(vacation)
    }
    if(i)i.closeSlidingItems();
  }
  enable(vacation,i?){
    this.sql.set('Vacations','vacation_id',vacation.vacation_id,'enabled',1,(res)=>{
      vacation.enabled = true;
      if(i)i.closeSlidingItems();
    });
  }
  disable(vacation,i?){
    this.sql.set('Vacations','vacation_id',vacation.vacation_id,'enabled',0,(res)=>{
      vacation.enabled = false;
      if(i)i.closeSlidingItems();
    });
  }
  delete(vacation, item?) { 
    if(confirm(this.sql.word.Delete_Vacation_Confirmation)) {
      this.sql.delete('Vacations','vacation_id',vacation.vacation_id);
      this.get_vacations();
    } else { 
      if(item)item.closeSlidingItems(); 
    }
  }
  ngOnInit() {
    this.get_vacations();
  }
}